/**
 * Quantity break selector ("Buy 2 save 5%" ...).
 * Clicking a tier writes the quantity into the product form's quantity input and keeps the
 * highlighted tier in sync when the shopper uses the +/- buttons or types a number.
 */
const OPTION_SELECTOR = '[data-qty-break]';

/** @param {Element} root */
function getQuantityInput(root) {
  const form = root.closest('form');
  const input = form?.querySelector('input[name="quantity"]');
  return input instanceof HTMLInputElement ? input : null;
}

/** @param {Element} root */
function sync(root) {
  const input = getQuantityInput(root);
  if (!input) return;
  const current = parseInt(input.value, 10) || 1;
  let matched = false;
  root.querySelectorAll(OPTION_SELECTOR).forEach((option) => {
    const isMatch = Number(option.getAttribute('data-qty-break')) === current;
    option.setAttribute('aria-checked', isMatch ? 'true' : 'false');
    if (isMatch) matched = true;
  });
  // A custom quantity (e.g. 3) matches no tier: nothing is highlighted.
  root.toggleAttribute('data-custom-quantity', !matched);
}

function syncAll() {
  document.querySelectorAll('[data-qty-breaks]').forEach(sync);
}

if (!window.__qtyBreaksInit) {
  window.__qtyBreaksInit = true;

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const option = target?.closest(OPTION_SELECTOR);
    if (!option) return;
    const root = option.closest('[data-qty-breaks]');
    if (!root) return;
    const input = getQuantityInput(root);
    if (!input || input.disabled) return;

    input.value = option.getAttribute('data-qty-break') || '1';
    // Lets the theme's quantity component clamp the value and refresh its own state.
    input.dispatchEvent(new Event('blur'));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    sync(root);
  });

  document.addEventListener('quantity-selector:update', () => requestAnimationFrame(syncAll));
  document.addEventListener('input', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.name === 'quantity') syncAll();
  });
  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.name === 'quantity') syncAll();
  });
}

class QtyBreaks extends HTMLElement {
  connectedCallback() {
    sync(this);
    // The form is morphed after a variant change; re-sync once it has settled.
    requestAnimationFrame(() => sync(this));
  }
}

if (!customElements.get('qty-breaks')) {
  customElements.define('qty-breaks', QtyBreaks);
}

syncAll();
